import { useCallback, useState, useRef, useMemo } from 'react';
import { subDays, subHours, subMinutes } from 'date-fns';
import { Box, Container, Stack, Typography, Divider, Tabs, Tab } from '@mui/material';
import { Seo } from 'src/components/seo';
import { usePageView } from 'src/hooks/use-page-view';
import { useTranslation } from 'react-i18next';
import { appStr } from 'src/locales/app_strings';
import { AccountGeneralSettings } from './account/account-general-settings';
import { AccountSecuritySettings } from './account/account-security-settings';
import { useUser } from 'src/hooks/use-auth';
import { getAvatar } from 'src/services/AssetApi';
import { useIsMobile } from 'src/contexts/mobile-context';

const now = new Date();

const Page = () => {
  const rootRef = useRef(null);
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  const user = useUser();
  const [currentTab, setCurrentTab] = useState('general');
  usePageView();

  const tabs = useMemo(() => ([
    { label: t(appStr.txt_045), value: 'general' },
    { label: t(appStr.txt_046), value: 'security' },
  ]), [t]);

  const handleTabsChange = useCallback((event, value) => {
    setCurrentTab(value);
  }, []);
  
  return (
    <>
      <Seo title="Account" />
      <Box component="main" ref={rootRef} sx={{ flexGrow: 1, py: 0.5 }}>
        <Container maxWidth="xl" sx={isMobile ? { px: 1 } : {px: 3}}>
          <Stack spacing={1} sx={{ mb: 1 }}>
            <Typography variant="h5" color="text.primary">{t(appStr.txt_044)}</Typography>
            <>
              <Tabs
                indicatorColor="primary"
                onChange={handleTabsChange}
                scrollButtons="auto"
                textColor="primary"
                value={currentTab}
                variant="scrollable"
              >
                {tabs.map((tab) => (
                  <Tab key={tab.value} label={tab.label} value={tab.value} />
                ))}
              </Tabs>
              <Divider />
            </>
          </Stack>
          {currentTab === 'general' && (
            <AccountGeneralSettings
              avatar={getAvatar(user.avatar) || ''}
              email={user.email || ''}
              name={user.name || ''}
            />
          )}
          {currentTab === 'security' && (
            <AccountSecuritySettings
              loginEvents={[
                {
                  id: '1bd6d44321cb78fd915462fa',
                  createdAt: subDays(
                    subHours(subMinutes(now, 5), 7),
                    1,
                  ).getTime(),
                  ip: '95.130.17.84',
                  type: 'Credential login',
                  userAgent: 'Chrome, Mac OS 10.15.7',
                },
                {
                  id: 'bde169c2fe9adea5d4598ea9',
                  createdAt: subDays(
                    subHours(subMinutes(now, 25), 9),
                    1,
                  ).getTime(),
                  ip: '95.130.17.84',
                  type: 'Credential login',
                  userAgent: 'Chrome, Mac OS 10.15.7',
                },
              ]}
            />
          )}
        </Container>
      </Box>
    </>
  );
};

export default Page;
